import React, {Fragment, useEffect,  useState} from 'react';
import PropTypes from "prop-types";

import {useForm} from "react-hook-form";
import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse} from "../../../DataFunctions/BaseDataFns";
import SpinnerDiv from "../../../ui/ReactSpinnerDiv";
import {getConcernReportDetails, createConcernReport, updateConcernReport} from "../../../DataFunctions/ConcernReportDataFns";

import {ErrorDiv} from "root/ReactHookForm/FormComponents";
import DropdownPupil from "root/ReactHookForm/ui/DropdownPupil";
import DropdownConcernReportType from "root/ReactHookForm/ui/DropdownConcernReportType";

const ModalAddConcernReport = ({cr_id, school_id, onSaveCompleted, onClose, mode, width}) =>
{
    const [ buttonState, setButtonState ] = useState ('') ;
    const [data, setData] = useState({ isLoading: true, data: [] });

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                concern_report: {
                    pupil_UID: null,
                    reference_number: '',
                    status: '',
                    type: null,
                    reported_on: '',
                    opened_on: '',
                    closed_on: '',
                    report_owner: '',
                    report_body: '',
                    closing_rep : ''
                }
            }
        });

    const titles = {
        view: 'View Concern Report',
        edit: 'Process Concern Report',
        create: 'New Concern Report',
    } ;

    const getDefaultData = () =>
    {
        return {
            message: '',
        }
    }

    useEffect(() =>
    {
        if ( mode !== 'create' )
        {
            getConcernReport();
        }
        else
        {
            setData({ isLoading: false, data: getDefaultData() });
        }
    }, []);

    //Get the cr details
    const getConcernReport = (data) =>
    {
        getConcernReportDetails(cr_id, (response) =>
        {
            let cr_data = getDataFromResponse(response)[0] ;

            setValue('concern_report',
                {
                    pupil_UID:  { value: cr_data.pupilUID},
                    reference_number: cr_data.reference,
                    status: cr_data.status,
                    type: { value: cr_data.id},
                    reported_on: cr_data.date_created,
                    opened_on: cr_data.date_opened,
                    closed_on: cr_data.date_closed,
                    report_owner: cr_data.owner,
                    report_body: cr_data.message,
                    closing_rep : cr_data.closing_rep
                });
                
            setData({ isLoading: false, data: cr_data });
        });
    }

    const onClickCancel = () =>
    {
        onSaveCompleted ('cancel');
        onClose() ;
    }

    const doCreateConcernReport = ( formData, action ) =>
    {
        createConcernReport(formData, action, (response) =>
        {
            onSaveCompleted ('saved');
            onClose() ;
        });
    }

    const doUpdateConcernReport = ( formData, action ) =>
    {
        updateConcernReport(cr_id, action, formData, (response) =>
        {
            onSaveCompleted ('saved');
            onClose() ;
        });
    }

    const title = ( ) =>
    {
        return <h3>{titles[mode]}</h3>
    }

    const isViewOnly = mode === 'view';

    const onSubmit = (data, action) =>
    {
        switch (action)
        {
            case 'create':
                doCreateConcernReport(data, action);
                break;

            case 'edit':
                doUpdateConcernReport(data, action);
                break;

            case 'close':

                if (mode === 'create')
                {
                    doCreateConcernReport(data, action);
                }
                else
                {
                    doUpdateConcernReport(data, action);
                }
                break;
        }

    }

    const getSaveButtonStyle= () =>
    {
        return "btn btn-icon btn-primary btn-icon-right btn-small" ;
    }

    const onClickSave = (action) =>
    {
        handleSubmit(onSubmit)(action);
    }

    const SaveButton = (onClickSave) =>
    {
        const clickHandler = buttonState === '' ? onClickSave : null;

        return (
            <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSaveButtonStyle()}>Save<i className="et-save" /></button>
        )
    }

    const CloseButton = (onClickSave) =>
    {
        const clickHandler = buttonState === '' ? onClickSave : null;

        return (
            <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className='btn btn-icon btn-danger btn-icon-right btn-small'>Close Concern Report<i className="et-save" /></button>
        )
    }

    const validateDropdown = (val) =>
    {
        if (+(val.value) === 0)
        {
            return "You must select a pupil";
        }
    }

    const renderHookForm = ()  =>
    {
        const readOnlyMode = mode === 'view' ? 'readonly' : '' ;
        const pupilReadOnly =  mode !== 'create' ;
        const concernTypeReadOnly =  mode === 'view' ;

        return (
            <Fragment>

                <form className='registration-form' onSubmit={handleSubmit()}>
                    <div className='row'>
                        <div className='col-md-6'>

                            <div style={{marginBottom: '10px'}}>
                                <label>Pupil</label>
                                <DropdownPupil readOnly={pupilReadOnly} control={control}
                                                         mode={mode} name='concern_report.pupil_UID'
                                                         rules={{required: true, validate: validateDropdown}}
                                                         school_id={school_id}
                                                         placeholder='Please select a Pupil'
                                                         isSearchable={true}/>
                                {formErrors.concern_report?.pupil_UID &&
                                    <ErrorDiv>{formErrors.concern_report.pupil_UID.message}</ErrorDiv>}
                            </div>

                        </div>

                        {mode !== 'create' &&
                            <div className='col-md-6'>
                                <div style={{marginBottom: '10px'}}>
                                    <label>Reference No</label>
                                    <input readOnly='readonly' className='form-control'
                                           name='concern_report.reference_number'
                                           id='reference_number' {...register("concern_report.reference_number", {required: false})} />
                                </div>
                            </div>
                        }
                    </div>

                    <div className='row'>
                        {mode !== 'create' &&
                            <div className='col-md-6'>
                                <div style={{marginBottom: '10px'}}>
                                    <label>Status</label>
                                    <input readOnly='readonly' className='form-control' name='concern_report.status'
                                           id='status' {...register("concern_report.status", {required: false})} />
                                </div>
                            </div>
                        }

                        <div className='col-md-6' style={{marginBottom: '10px'}}>
                            <label>Concern Report Type</label>
                            <DropdownConcernReportType readOnly={concernTypeReadOnly} control={control}
                                           mode={mode} name='concern_report.type'
                                           rules={{required: true, validate: validateDropdown}}
                                           placeholder='Please select a concern type'
                                           isSearchable={true}/>
                            {formErrors.concern_report?.type &&
                                <ErrorDiv>{formErrors.concern_report.type.message}</ErrorDiv>}
                        </div>

                    </div>

                    {mode !== 'create' &&
                        <div className='row'>
                            <div className='col-md-6'>
                                <div style={{marginBottom: '10px'}}>
                                    <label>Reported On</label>
                                    <input readOnly='readonly' className='form-control'
                                           name='concern_report.reported_on'
                                           id='reported_on' {...register("concern_report.reported_on", {required: false})} />
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div style={{marginBottom: '10px'}}>
                                    <label>Opened On</label>
                                    <input readOnly='readonly' className='form-control' name='concern_report.opened_on'
                                           id='opened_on' {...register("concern_report.opened_on", {required: false})} />
                                </div>
                            </div>
                        </div>
                    }

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Message</label>
                                <textarea readOnly={readOnlyMode}  style={{minHeight: '10em'}} name='concern_report.report_body'
                                          className='form-control'
                                          id='message' {...register("concern_report.report_body")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Actions</label>
                                <textarea readOnly={readOnlyMode} style={{minHeight: '10em'}}
                                          name='concern_report.closing_rep' className='form-control'
                                          id='closing_rep' {...register("concern_report.closing_rep")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        {data.data.status === 'closed' &&
                            <div className='col-md-6'>
                                <div style={{marginBottom: '10px'}}>
                                    <label>Closed On</label>
                                    <input readOnly='readonly' className='form-control' name='concern_report.closed_on'
                                           id='closed_on' {...register("concern_report.closed_on", {required: false})} />
                                </div>
                            </div>
                        }

                        {mode !== 'create' &&
                            <div className='col-md-6'>
                                <div style={{marginBottom: '10px'}}>
                                    <label>Owner</label>
                                    <input readOnly='readonly' className='form-control'
                                           name='concern_report.report_owner'
                                           id='report_owner' {...register("concern_report.report_owner", {required: false})} />
                                </div>
                            </div>
                        }
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        <button onClick={onClickCancel} className="btn btn-secondary" style={{marginRight: '10px'}}>Cancel<i className="et-arrow-bold-left" /></button>
                        {!isViewOnly && SaveButton (() => onClickSave(mode))}
                        {!isViewOnly && CloseButton (() => onClickSave('close'))}

                    </div>

                </form>

            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">

            { title() }

            <div style={{width: width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalAddConcernReport;

ModalAddConcernReport.defaultProps =
    {
        width: '600px'
    }

ModalAddConcernReport.propTypes = {
    cr_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
